import React from "react"
import Widget from "../LampWidget"

export default (props) => {
  return <Widget {...props} />
}
